import { render, staticRenderFns } from "./AddCustomerForm.vue?vue&type=template&id=28562388&scoped=true"
import script from "./AddCustomerForm.vue?vue&type=script&lang=js"
export * from "./AddCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerForm.vue?vue&type=style&index=0&id=28562388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28562388",
  null
  
)

export default component.exports